// Angular service to handle signup
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { APIRoutes } from '../global-misc/api-routes';
import { CreateAccountModel } from '../global-data-models/create-account.model';

@Injectable({ providedIn: 'root' })
export class SignupService {
  constructor(private http: HttpClient) {}

  async signup(model: CreateAccountModel): Promise<{ token: string }> {
    const response = await firstValueFrom(this.http.post<{ token: string }>(APIRoutes.SIGNUP_ROUTE, model));

    if (!response) {
      throw new Error('No token returned from signup');
    }

    return response;
  }
}
